import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../components/Header";
import { MainButton } from "../../components/MainButton";
import { Menu } from "../../components/Menu";
import { useOrder } from "../../hooks/useOrder";

import PixImg from "../../assets/images/pix.png";
import { useAppConfig } from "../../hooks/useAppConfig";
import { ConfigType } from "../../contexts/AppConfigContext";
import { Loading } from "../../components/Loading";
import api from "../../services/api";

import "./index.css";
import { usePluginspace } from "../../hooks/usePluginspace";
import {
  CustomerType,
  MeasureType,
  OrderAddress,
  OrderContext,
  ProductType,
} from "../../contexts/OrderContext";
import { PluginspaceResponseType } from "../../contexts/PluginspaceContext";
import { ModalDelivery } from "../../components/ModalDelivery";
import Swal from "sweetalert2";
import { cpfCnpjNoMask, cpfMask, rtcToText } from "../../functions/mask";
import { ModalTerms } from "../../components/ModalTerms";
import { Input } from "../../components/Input/Input";
import Switch from "../../components/Switch/Switch";
// icones
import visaLogo from "../../assets/images/visa.svg";
import ticketLogo from "../../assets/images/ticket.svg";
import masterCardLogo from "../../assets/images/masterCard.svg";
import redeLogo from "../../assets/images/rede.svg";
import aleloLogo from "../../assets/images/alelo.svg";
import americaExpressLogo from "../../assets/images/americanExpress.svg";
import eloLogo from "../../assets/images/elo.svg";
import hiperCardLogo from "../../assets/images/hipercard.svg";
import maestroLogo from "../../assets/images/maestro.svg";
import { useFoodConfig } from "../../hooks/useFood";
import { calculatePriceFractionalToProduct } from "../../functions/price_functions";

type PluginconfigType = {
  id: number;
  pluginspaceId: number;
  plugintypeId: number;
  plugintemplateId: {
    id: number;
    name: string;
  };
  name: string;
  content: any;
};

type AddressLocationType = {
  cep: string;
  city: string;
  district: string;
  extra: string;
  number: string;
  state: string;
  street: string;
};

type LocationResponseType = {
  address: AddressLocationType;
  type: string;
  name: string;
  code: string;
};

type ProcessorWalletType = {
  externalCode: string;
  processorId: string;
};

type WalletType = {
  id: string;
  code: string;
  logo: string;
  name: string;
  processorDigitalWallets: ProcessorWalletType[];
};

type ProductCartType = {
  id: number;
  img: string;
  sku: string;
  variation: any;
  name: string;
  price: number;
  unitPrice: number;
  discount: number;
  discountGeral: number;
  promotional_price: number;
  quantity: number;
  code: string;
  sku_info: Array<{
    vendas: number;
    inventory: number;
    minimum_stock: number;
    measures?: MeasureType;
  }>;
};

type PlansType = {
  id: number;
  codePlan: number;
  installment: number;
};

type IntegrationType = {
  id: number;
  pluginconfigId: number;
  brand: string;
  cardOperator: number;
  codePay: string;
  nameGateway: string;
  paymentPlans: PlansType[];
  typePay: string;
  plugintemplateId: number;
};

export function OrderInfo() {
  const navigate = useNavigate();
  const { pluginspace_id } = useParams();
  const orderContext = useOrder();
  const { getToken, getThisPluginspace, registerAccess } = usePluginspace();

  const [maskCpfjCnpj, setMaskCpfjCnpj] = useState("999.999.999-99");
  const [cpfNote, setCpfNote] = useState("");
  const [useCpfNote, setUseCpfNote] = useState(1);
  const [paymentMethods, setPaymentMethods] = useState<Array<PluginconfigType>>(
    []
  );
  const [orderAddress, setOrderAddress] = useState<OrderAddress>();

  const { getAppConfig } = useAppConfig();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);
  const [gatewayIdSelected, setGatewayIdSelected] = useState(0);

  const [customer, setCustomer] = useState<CustomerType | any>();
  const [type, setType] = useState("");
  const [typePayment, setTypePayment] = useState("");
  const [wallets, setWallets] = useState<WalletType[]>([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { isTable, isCard } = useFoodConfig();
  const [momentType, setMomentType] = useState("before");
  const [paymentsAfter, setPaymentsAfter] = useState<IntegrationType[]>([]);
  const [selectedPaymentAfter, setSelectedPaymentAfter] =
    useState<IntegrationType | null>(null);
  const [typeAfter, setTypeAfter] = useState("card");
  const [paymentMoney, setPaymentMoney] = useState("");
  const [total, setTotal] = useState(0);
  const [havePaymentOnline, setHavePaymentOnline] = useState(false);
  const [isCounter, setIsCounter] = useState(false);
  const [internalDelivery, setInternalDelivery] = useState("");

  const [sellerInfo, setSellerInfo] = useState<any>(null);
  const [loadingHeader, setLoadingHeader] = useState(true);

  const [needChanges, setNeedChanges] = useState(false);

  const [paymentsAfterAble, setPaymentsAfterAble] = useState({
    ableCredit: false,
    ableDebit: false,
    ableAlimentation: false,
    ablePix: false,
    ableMoney: false,
  });
  const [nameTabeWithdrawal, setNameTabeWithdrawal] = useState<string | null>(
    null
  );

  const [location, setLocation] = useState("");

  useEffect(() => {
    registerAccess("order");
    getConfig();
    const isCounterStorage = localStorage.getItem("counter_number");
    setIsCounter(isCounterStorage ? true : false);
    const internalDeliveryNumber = localStorage.getItem("internal_number");
    const internalDeliveryName = localStorage.getItem("internal_name");
    if (internalDeliveryNumber && internalDeliveryName)
      setInternalDelivery(
        `${window.atob(internalDeliveryName)} ${window.atob(
          internalDeliveryNumber
        )}`
      );
  }, []);

  async function loadOrder() {
    localStorage.removeItem("qrcodePixPayment");
    if (window.location.search && window.location.search !== "") {
      const guidCart = window.location.search.split("=")[1];
      await getCart(guidCart);
    } else {
      const customerStorage = await orderContext.getCustomer();
      const typeStorage = await orderContext.getType();
      const orderAddressStorage = await orderContext.getOrderAddress();
      orderContext.setCpfInNote("");
      const totalValue = await orderContext.getTotalValue();
      const freight = await orderContext.getFreight();
      setTotal(totalValue + freight);
      setCpfNote(customerStorage.cpf);
      setCustomer(customerStorage);
      setType(typeStorage);
      setLocation(await findLocation(typeStorage));
      setOrderAddress(orderAddressStorage);
      await getPaymentMethods(0);
    }
  }

  async function getSellerInfo() {
    const sellerCPF = await orderContext.getSellerCpfCnpj();

    if (sellerCPF) {
      await api
        .post(
          "api/users/seller",
          {
            cpf: sellerCPF,
          },

          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          setSellerInfo(response.data.data[0]);
        })
        .catch((err) => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Erro",
            text: "Erro ao encontrar loja",
          });
        });
    }
  }

  async function getConfig() {
    setLoading(true);
    setLoadingHeader(true);
    const findedConfig: ConfigType | void = await getAppConfig();
    setLoadingHeader(false);
    setConfig(findedConfig);
    await orderContext.synchronizeContextToStorage();

    await loadOrder();
    if (findedConfig)
      await getOperators(findedConfig.content.pdv.gatewayDeliveryId);

    await getSellerInfo();
    setLoading(false);
  }

  async function getOperators(gatewayPaymentAfter: number) {
    const pluginspace = await getThisPluginspace();
    if (pluginspace) {
      const resIntegration = await api.post(
        "api/orders/card-payment-get",
        {
          hash: pluginspace.hash,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      );
      if (
        resIntegration.data &&
        resIntegration.data.data &&
        resIntegration.data.data.data &&
        resIntegration.data.success
      ) {
        setPaymentsAfter(
          resIntegration.data.data.data.filter(
            (pymt: IntegrationType) =>
              pymt.plugintemplateId === 44 &&
              pymt.pluginconfigId === gatewayPaymentAfter
          )
        );
      } else {
        setPaymentsAfter([]);
      }
    } else {
      setPaymentsAfter([]);
    }
  }

  async function getPaymentMethods(locationId: number) {
    const locationIdToSend = locationId
      ? locationId
      : await orderContext.getLocationId();
    await api
      .post(
        `/api/pluginconfig/filter`,
        {
          plugintypeId: 14,
          locationId: locationIdToSend ? locationIdToSend : null,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        const dataPayments = response.data.data.filter(
          (pluginconfigs: PluginconfigType) =>
            pluginconfigs.content.able === "1" ||
            pluginconfigs.content.ableCard === "1" ||
            pluginconfigs.content.ableDebit === "1" ||
            pluginconfigs.content.ablePix === "1" ||
            pluginconfigs.content.pix === "1" ||
            pluginconfigs.content.ableAlimentation === "1" ||
            pluginconfigs.content.ableMoney === "1"
        );
        response.data.data.forEach((config: any) => {
          if (config.content.paymentWithdrawalTabCustom) {
            setNameTabeWithdrawal(config.content.paymentWithdrawalTabCustom);
            return;
          }
        });
        const configStore = await getAppConfig();
        if (configStore && configStore.content && configStore.content.pdv) {
          const paymentDelivery = response.data.data.find(
            (pluginconfig: PluginconfigType) =>
              pluginconfig.id === configStore.content.pdv.gatewayDeliveryId
          );
          if (paymentDelivery && paymentDelivery.content) {
            if (paymentDelivery.content.pix)
              paymentDelivery.content.ablePix = paymentDelivery.content.pix;
            setPaymentsAfterAble({
              ableCredit:
                paymentDelivery.content.able &&
                paymentDelivery.content.able === "1"
                  ? true
                  : false,
              ableDebit:
                paymentDelivery.content.ableDebit &&
                paymentDelivery.content.ableDebit === "1"
                  ? true
                  : false,
              ableAlimentation:
                paymentDelivery.content.ableAlimentation &&
                paymentDelivery.content.ableAlimentation === "1"
                  ? true
                  : false,
              ablePix:
                paymentDelivery.content.ablePix &&
                paymentDelivery.content.ablePix === "1"
                  ? true
                  : false,
              ableMoney:
                paymentDelivery.content.ableMoney &&
                paymentDelivery.content.ableMoney === "1"
                  ? true
                  : false,
            });
          }
          const paymentsOnline = dataPayments.filter(
            (pluginconfigs: PluginconfigType) =>
              pluginconfigs.plugintemplateId.id !== 44 &&
              (pluginconfigs.id === configStore.content.pdv.gatewayId ||
                pluginconfigs.id === configStore.content.pdv.gatewayPixId)
          );

          setHavePaymentOnline(paymentsOnline && paymentsOnline.length > 0);
        }
        setPaymentMethods(dataPayments);
        const paymentHub = dataPayments.find(
          (pluginconfigs: PluginconfigType) =>
            pluginconfigs.plugintemplateId.id === 25
        );
        const pluginspaceData: void | PluginspaceResponseType =
          await getThisPluginspace();
        if (paymentHub) {
          await api
            .post(
              `/api/totvshub/listWalletPay`,
              {
                pluginspaceId: pluginspaceData ? pluginspaceData.id : 0,
                gatewayId: paymentHub.id,
              },
              {
                headers: {
                  Authorization: `Bearer ${await getToken()}`,
                },
              }
            )
            .then((responseWallet) => {
              const walletsResponse = responseWallet.data.paymentMethods;
              setWallets(walletsResponse);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function choosePayment() {
    if (momentType === "after") {
      if (!selectedPaymentAfter) {
        Swal.fire({
          icon: "warning",
          title: "Atenção!",
          text: "Selecione um meio de pagamento.",
        });
        return;
      }
      orderContext.setIntegrationPlan({
        codePay: selectedPaymentAfter.codePay,
        codePlan:
          selectedPaymentAfter.paymentPlans &&
          selectedPaymentAfter.paymentPlans[0]
            ? selectedPaymentAfter.paymentPlans[0].codePlan
            : 0,
        nameGateway: selectedPaymentAfter.nameGateway,
        nameBrand: selectedPaymentAfter.brand,
        typePayment: typeAfter,
      });
      if (
        selectedPaymentAfter.cardOperator === 100 &&
        (!paymentMoney || total > parseFloat(paymentMoney))
      ) {
        Swal.fire({
          icon: "warning",
          title: "Atenção!",
          text: "O pagamento em dinheiro deve ser maior ou igual ao valor da compra.",
        });
        return;
      }
      orderContext.setChangePayment(
        parseFloat((parseFloat(paymentMoney) - total).toFixed(2))
      );
    } else {
      orderContext.setChangePayment(0);
    }
    await orderContext.totalValueOrder();
    setLoading(true);
    if (cpfNote === "" || !cpfNote || cpfNote.includes("_")) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "É necessário informar um CPF válido na nota",
      });
      setLoading(false);
      return;
    }

    if (!gatewayIdSelected) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "É necessário informar um meio de pagamento",
      });
      setLoading(false);
      return;
    }

    const paymentTypeStorage = await orderContext.getPaymentType();

    if (useCpfNote === 1) {
      orderContext.setCpfInNote(cpfNote);
    } else {
      orderContext.setCpfInNote("");
    }
    orderContext.setIsCpfInNote(useCpfNote);
    if (paymentTypeStorage.includes("card")) {
      const orderToStorage = Object.assign(orderContext);
      await orderContext.encryptOrderStorage(orderToStorage);
      setLoading(false);
      navigate(`/${pluginspace_id}/card`);
    } else if (
      paymentTypeStorage.includes("pix") ||
      paymentTypeStorage.includes("shipay") ||
      paymentTypeStorage.includes("wallet")
    ) {
      const orderToStorage = Object.assign(orderContext);
      await orderContext.encryptOrderStorage(orderToStorage);
      setLoading(false);
      navigate(`/${pluginspace_id}/order-finalize`);
    } else if (paymentTypeStorage.includes("delivery-payment")) {
      // await generateCodePayPlanDelivery();
      const orderToStorage = Object.assign(orderContext);
      await orderContext.encryptOrderStorage(orderToStorage);
      setLoading(false);
      navigate(`/${pluginspace_id}/order-finalize`);
    }
  }

  async function getCart(guid: string) {
    await api
      .get(`/api/customerCart/guid/${guid}`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const config = await getAppConfig();
        const order = response.data.data[0];

        const carrinhoDataCriacao = new Date(order.created);
        const now = new Date(); // Data e hora atuais

        const hour = config
          ? config.content.pdv.sellerCartExpirationTime.split(":")[0]
          : "2";
        const minute = config
          ? config?.content.pdv.sellerCartExpirationTime.split(":")[1]
          : "0";

        const validTimeCart = new Date(
          carrinhoDataCriacao.getFullYear(),
          carrinhoDataCriacao.getMonth(),
          carrinhoDataCriacao.getDate(),
          carrinhoDataCriacao.getHours() + parseInt(hour),
          carrinhoDataCriacao.getMinutes() + parseInt(minute)
        );

        if (now > validTimeCart) {
          Swal.fire({
            icon: "warning",
            titleText: "Carrinho expirado",
            text: "O carrinho do vendedor está expirado. Favor entrar em contato com o seu vendedor",
          }).then(() => navigate(`/${pluginspace_id}/category`));
        }

        orderContext.setGuidCart(guid);
        const customerCart = response.data.data[0];
        const adress = customerCart.jsonCart.address;
        setOrderAddress(adress);

        orderContext.setGuidCartPaymentOrder(true);

        orderContext.changeCustomerDocument(customerCart.cpfCustomer);
        orderContext.setFreight(customerCart.jsonCart.freight);
        orderContext.setType(customerCart.jsonCart.type);
        if (customerCart && customerCart.cpfSeller) {
          orderContext.setSellerCpfCnpj(response.data.data[0].cpfSeller);
        }
        orderContext.changeCustomerDocument(customerCart.cpfCustomer);
        setCpfNote(cpfMask(customerCart.cpfCustomer));
        orderContext.setOrderAddress(adress);
        const productsCart = customerCart.jsonCart.products.map(
          (product: ProductCartType) => {
            const variationFormated: any = {};
            product.variation.map((variation: any) => {
              variationFormated[variation.grid] = variation.value
                ? variation.value
                : variation.valor;
            });
            const newProduct: ProductType = {
              id: product.id,
              image: product.img,
              code: product.code,
              locationId: customerCart.locationId,
              name: product.name,
              promotionalPrice: product.promotional_price,
              quantity: product.quantity,
              sku: product.sku,
              stock: product.sku_info[0].inventory,
              unitPrice: product.unitPrice,
              variation: variationFormated,
              pluginspaceHash: pluginspace_id ? pluginspace_id : "",
              outStock: false,
              measures: product.sku_info[0].measures
                ? product.sku_info[0].measures
                : null,
            };
            return newProduct;
          }
        );

        await orderContext.changeOrderByGuidCart(productsCart, orderContext);

        await saveTotalandDiscount(productsCart);
        await findCustomer(customerCart.cpfCustomer);

        const locationIdSend = await findLocationId(customerCart.jsonCart.type);
        await getPaymentMethods(locationIdSend ? locationIdSend : 0);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function saveTotalandDiscount(products: any[]) {
    let newTotal = 0;
    let newTotalWithoutDiscount = 0;
    products.map((prod) => {
      if (
        prod.unitPrice === prod.promotionalPrice ||
        prod.promotionalPrice === 0
      ) {
        newTotal += prod.quantity * prod.unitPrice;
      } else {
        newTotal += prod.quantity * prod.promotionalPrice;
      }
      newTotalWithoutDiscount += prod.quantity * prod.unitPrice;
      if (prod.additionals) {
        prod.additionals.map((additional: any) => {
          newTotalWithoutDiscount +=
            prod.quantity * (additional.quantity * additional.price);
          newTotal += prod.quantity * (additional.quantity * additional.price);
        });
      }
      if (prod.fractions && prod.fractions.length > 0) {
        let priceFractional = calculatePriceFractionalToProduct(prod);
        newTotalWithoutDiscount += prod.quantity * priceFractional;
        newTotal += prod.quantity * priceFractional;
      }
      return prod;
    });

    orderContext.setTotalValue(newTotal);
    orderContext.setTotalValueWithoutDiscount(newTotalWithoutDiscount);
  }

  async function findCustomer(documento: string) {
    setLoading(true);
    const cpfWithouthMask = cpfCnpjNoMask(documento);
    await api
      .post(
        `/api/customer/filter`,
        {
          cpf: cpfWithouthMask,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data.data.length > 0) {
          const customerRes = response.data.data[0];
          setCustomer({
            name: customerRes.name,
            cpf: cpfMask(customerRes.cpf),
          });
          let customerResponse: CustomerType = {
            id:
              customerRes.id || customerRes.id === 0
                ? customerRes.id
                : customerRes.dados.id,
            name: customerRes.name,
            email: customerRes.email,
            cpf: customerRes.cpf,
            birthdate: customerRes.birthDate,
            wppNotification: customerRes.optinWhatsapp,
            acceptTermDate:
              customerRes.lgpdDataAceiteCarta ||
              customerRes.lgpdDataAceiteCarta === ""
                ? customerRes.lgpdDataAceiteCarta
                : customerRes.dados.lgpdDataAceiteCarta,
            gender: customerRes.gender,
            telephone: customerRes.customerPhones[0]
              ? customerRes.customerPhones[0].numberPhone
              : "",
            cep: customerRes.customerAddresses[0].zipCode,
            address: customerRes.customerAddresses[0].street,
            district: customerRes.customerAddresses[0].district,
            city: customerRes.customerAddresses[0].city,
            state: customerRes.customerAddresses[0].state,
            number: customerRes.customerAddresses[0].number,
            complement: customerRes.customerAddresses[0].extra,
            ibge: customerRes.customerAddresses[0].ibgeCode,
            inscEstadual: customerRes.customerAddresses[0].zipCode,
          };
          if (response.data.dados && response.data.dados.customerId) {
            customerResponse.customerWinthor = response.data.dados.customerId;
          }
          orderContext.setCustomer(customerResponse);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function findLocation(type: string) {
    return await api
      .get(`/api/location`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const location = response.data.data.find(
          (location: LocationResponseType) => location.code == type
        );
        return location ? location.name : "Entrega";
      })
      .catch((err) => {
        console.log(err);
        return "Entrega";
      });
  }

  async function findLocationId(type: string) {
    return await api
      .get(`/api/location`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const location = response.data.data.find(
          (location: LocationResponseType) => location.code == type
        );
        orderContext.setLocationId(location.id);
        return location ? location.id : 0;
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Erro ao encontrar loja",
        });
        return 0;
      });
  }

  function changePayment(payment: string, paymentId: number) {
    orderContext.setPaymentType(payment);
    orderContext.setGatewayId(paymentId);
    setGatewayIdSelected(paymentId);
    setTypePayment(payment);
  }

  function chooseModality() {
    switch (type) {
      case "withdraw":
        return "Retirada";
      case "delivery":
        return "Entrega";
      case "table":
        return "Mesa";
      case "counter":
        return "Retirada Balcão";
      case "synkar":
        const landmark = localStorage.getItem("landmark_synkar");
        if (
          landmark &&
          window.atob(landmark) &&
          JSON.parse(window.atob(landmark))
        ) {
          const landmarkItem = JSON.parse(window.atob(landmark));
          return `${location ? `${location} - ` : ""}${landmarkItem.landmark}`;
        } else return "Entrega";
      case "internal-delivery":
        const internalDeliveryNumber = localStorage.getItem("internal_number");
        const internalDeliveryName = localStorage.getItem("internal_name");
        if (internalDeliveryNumber && internalDeliveryName)
          return `Entrega - ${window.atob(internalDeliveryName)} ${window.atob(
            internalDeliveryNumber
          )}`;
        else return "Entrega Interna";
      default:
        return "Retirada";
    }
  }

  function cardIcon(cardBrand: string) {
    switch (cardBrand) {
      case "visa":
        return (
          <img
            src={visaLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );

      case "mastercard":
        return (
          <img
            src={masterCardLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "americanexpress":
        return (
          <img
            src={americaExpressLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "elo":
        return (
          <img
            src={eloLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "hipercard":
        return (
          <img
            src={hiperCardLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "maestro":
        return (
          <img
            src={maestroLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "rede":
        return (
          <img
            src={redeLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "ticket":
        return (
          <img
            src={ticketLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      case "alelo":
        return (
          <img
            src={aleloLogo}
            style={{
              width: "32px",
              height: "auto",
            }}
          />
        );
      default:
        return (
          <>
            <div
              style={{
                width: "32px",
                height: "auto",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <i
                className="fa fa-credit-card"
                style={{
                  color: "#3C9EE5",
                }}
              />
            </div>
          </>
        );
    }
  }

  function chooseMethodPaymentDefault() {
    if (havePaymentOnline) {
      setMomentType("before");
    } else if (paymentsAfter && paymentsAfter.length > 0) {
      setMomentType("after");
    }
  }

  function chooseTextAddress(typeAddress: string) {
    let textAddress = "";
    switch (typeAddress) {
      case "withdraw":
        textAddress = "Endereço de Retirada: ";
        break;
      case "delivery":
        textAddress = "Endereço de Entrega: ";
        break;
      case "internal-delivery":
        textAddress = "Local de Entrega: ";
        break;
    }
    if (textAddress && orderAddress) {
      return (
        <div
          className="store-infos"
          style={internalDelivery ? { margin: 0 } : {}}
        >
          <p>
            <b>{textAddress}</b>
            {internalDelivery ? (
              <>{internalDelivery}</>
            ) : (
              <>
                {" " +
                  orderAddress.address +
                  ", " +
                  orderAddress.number +
                  (orderAddress.complement
                    ? " " + orderAddress.complement
                    : " ") +
                  ", " +
                  orderAddress.district +
                  " - " +
                  orderAddress.city +
                  (orderAddress.reference
                    ? " - " + orderAddress.reference
                    : "") +
                  (orderAddress.cep ? " - CEP: " + orderAddress.cep : "")}
              </>
            )}
          </p>
        </div>
      );
    } else return <></>;
  }

  useEffect(() => {
    chooseMethodPaymentDefault();
  }, [havePaymentOnline, paymentsAfter]);

  return (
    <div className="order-info">
      <ModalDelivery
        isOpen={modalIsOpen}
        setIsOpen={setModalIsOpen}
        backgroundButton={
          config?.webappcolor.webappbutton && config.webappcolor.webappbutton
        }
        fontButton={
          config?.webappcolor.fontbutton && config.webappcolor.fontbutton
        }
        goCustomer={false}
      />

      <div className="content-order-info">
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className="order-info-body">
            <h2>Informações da compra</h2>
            {customer && orderAddress && (
              <div className="order-info-details">
                {type === "delivery" && (
                  <h4
                    onClick={() => {
                      setModalIsOpen(true);
                    }}
                  >
                    Editar
                  </h4>
                )}
                <div
                  className="customer-infos"
                  style={
                    internalDelivery || type === "counter" ? { margin: 0 } : {}
                  }
                >
                  <p>
                    <b>Cliente:</b> {customer.name}
                  </p>
                  <p>
                    <b>CPF: </b>
                    {cpfMask(customer.cpf)}
                  </p>
                  {type === "withdraw" && (
                    <p>
                      <b>Loja: </b>
                      {orderAddress.name}
                    </p>
                  )}
                </div>

                {chooseTextAddress(type)}

                {!internalDelivery && (
                  <p className="order-modality">
                    <b>Modalidade: </b>
                    {chooseModality()}
                  </p>
                )}
                {type === "withdraw" &&
                  orderAddress &&
                  orderAddress.otherPersonToWithdrawal && (
                    <p className="order-modality">
                      <b>Responsável pela retirada: </b>
                      {`${
                        orderAddress.otherPersonToWithdrawal.name
                          ? orderAddress.otherPersonToWithdrawal.name
                          : ""
                      } 
											${
                        orderAddress.otherPersonToWithdrawal.cpf
                          ? orderAddress.otherPersonToWithdrawal.cpf
                          : ""
                      }`}
                    </p>
                  )}
              </div>
            )}

            {sellerInfo && (
              <>
                <h2 style={{ marginTop: "2em" }}>Informações do Vendedor</h2>

                <div className="order-info-details">
                  <p>
                    <b>Nome: </b>
                    {sellerInfo.name}
                  </p>
                </div>
              </>
            )}

            <h2 style={{ marginTop: "2em" }}>Pagamento</h2>
            <div className="cpf-in-note">
              <p>
                {cpfCnpjNoMask(cpfNote).length >= 12 ? "CNPJ" : "CPF"} na nota:{" "}
                {cpfNote}
              </p>
            </div>

            <div className="payment-tab" style={{ marginTop: "2em" }}>
              <div className="payment-tab-options">
                {havePaymentOnline && (
                  <div
                    className="payment-tab-option"
                    onClick={() => {
                      setMomentType("before");
                    }}
                    style={{
                      opacity: momentType !== "before" ? "50%" : "100%",
                    }}
                  >
                    <span>Pague antecipado</span>
                  </div>
                )}

                {paymentsAfter &&
                  paymentsAfter.length > 0 &&
                  !isCounter &&
                  !isTable &&
                  !isCard &&
                  paymentMethods.map((payment) => {
                    if (
                      payment.id === config?.content.pdv.gatewayDeliveryId &&
                      payment.plugintemplateId.id === 44
                    ) {
                      return (
                        <div
                          className="payment-tab-option"
                          onClick={() => {
                            changePayment("delivery-payment", payment.id);
                            setMomentType("after");
                          }}
                          style={{
                            opacity: momentType === "before" ? "50%" : "100%",
                          }}
                        >
                          {(nameTabeWithdrawal && (
                            <span>{nameTabeWithdrawal}</span>
                          )) || <span>Pague ao receber</span>}
                        </div>
                      );
                    }
                  })}
              </div>
              {/*Pagamentos Antecipados*/}
              {momentType === "before" && (
                <div className="payment-tab-moment-type">
                  {paymentMethods.map((payment) => {
                    if (payment.id === config?.content.pdv.gatewayId) {
                      switch (payment.plugintemplateId.id) {
                        case 25:
                          let ableCard = false;

                          Object.entries(payment.content).forEach((config) => {
                            if (
                              config[0].replace(/\W/gi, "") === "ableCard" &&
                              config[1] === "1"
                            ) {
                              ableCard = true;
                            }
                          });
                          if (
                            ableCard &&
                            payment.id === config?.content.pdv.gatewayPixId &&
                            wallets
                          ) {
                            return (
                              <>
                                <div className={"payment-card-option"}>
                                  <span>Cartão de Crédito</span>
                                </div>
                                <div
                                  className={
                                    gatewayIdSelected === payment.id &&
                                    typePayment === "totvs-card"
                                      ? "type-method-selected"
                                      : "type-method"
                                  }
                                  onClick={() =>
                                    changePayment("totvs-card", payment.id)
                                  }
                                >
                                  <i
                                    className="fa fa-credit-card"
                                    style={{
                                      color: "#3C9EE5",
                                      width: "32px",
                                      height: "auto",
                                    }}
                                  />
                                  <p>Cartão de crédito</p>
                                </div>
                                {wallets.map((wallet: WalletType) => (
                                  <div
                                    className={
                                      gatewayIdSelected === payment.id &&
                                      typePayment === `${wallet.code}-wallet`
                                        ? "type-method-selected"
                                        : "type-method"
                                    }
                                    onClick={() =>
                                      changePayment(
                                        `${wallet.code}-wallet`,
                                        payment.id
                                      )
                                    }
                                  >
                                    <img src={wallet.logo} alt={wallet.name} />
                                    <p>{wallet.name}</p>
                                  </div>
                                ))}
                              </>
                            );
                          } else if (
                            payment.id === config?.content.pdv.gatewayPixId &&
                            wallets &&
                            !ableCard
                          ) {
                            return (
                              <>
                                <div className={"payment-card-option"}>
                                  <span>Carteira</span>
                                </div>
                                {wallets.map((wallet: WalletType) => (
                                  <div
                                    className={
                                      gatewayIdSelected === payment.id &&
                                      typePayment === `${wallet.code}-wallet`
                                        ? "type-method-selected"
                                        : "type-method"
                                    }
                                    onClick={() =>
                                      changePayment(
                                        `${wallet.code}-wallet`,
                                        payment.id
                                      )
                                    }
                                  >
                                    <img src={wallet.logo} alt={wallet.name} />
                                    <p>{wallet.name}</p>
                                  </div>
                                ))}
                              </>
                            );
                          } else if (ableCard) {
                            return (
                              <div
                                className={
                                  gatewayIdSelected === payment.id &&
                                  typePayment === "totvs-card"
                                    ? "type-method-selected"
                                    : "type-method"
                                }
                                onClick={() =>
                                  changePayment("totvs-card", payment.id)
                                }
                              >
                                <i
                                  className="fa fa-credit-card"
                                  style={{
                                    color: "#3C9EE5",
                                    width: "32px",
                                    height: "auto",
                                  }}
                                />
                                <p>Cartão de crédito</p>
                              </div>
                            );
                          } else return <></>;
                        case 12:
                          return (
                            <div
                              className={
                                gatewayIdSelected === payment.id &&
                                typePayment === "esitef-card"
                                  ? "type-method-selected"
                                  : "type-method"
                              }
                              onClick={() =>
                                changePayment("esitef-card", payment.id)
                              }
                            >
                              <i
                                className="fa fa-credit-card"
                                style={{
                                  color: "#3C9EE5",
                                  width: "32px",
                                  height: "auto",
                                }}
                              />
                              <p>Cartão de crédito</p>
                            </div>
                          );
                        case 20:
                          return (
                            <>
                              <div className={"payment-card-option"}>
                                <span>Cartão de Crédito</span>
                              </div>
                              <div
                                className={
                                  gatewayIdSelected === payment.id &&
                                  typePayment === "cielo-card"
                                    ? "type-method-selected"
                                    : "type-method"
                                }
                                onClick={() =>
                                  changePayment("cielo-card", payment.id)
                                }
                              >
                                <i
                                  className="fa fa-credit-card"
                                  style={{
                                    color: "#3C9EE5",
                                    width: "32px",
                                    height: "auto",
                                  }}
                                />
                                <p>Cartão de crédito</p>
                              </div>
                            </>
                          );
                        case 10:
                          if (
                            payment.id === config?.content.pdv.gatewayPixId &&
                            payment.content.pix === "1"
                          ) {
                            return (
                              <>
                                <div className={"payment-card-option"}>
                                  <span>Cartão de Crédito</span>
                                </div>
                                <div
                                  className={
                                    gatewayIdSelected === payment.id &&
                                    typePayment === "pagseguro-card"
                                      ? "type-method-selected"
                                      : "type-method"
                                  }
                                  onClick={() =>
                                    changePayment("pagseguro-card", payment.id)
                                  }
                                >
                                  <i
                                    className="fa fa-credit-card"
                                    style={{
                                      color: "#3C9EE5",
                                      width: "32px",
                                      height: "auto",
                                    }}
                                  />
                                  <p>Cartão de crédito</p>
                                </div>
                                <div
                                  className={
                                    gatewayIdSelected === payment.id &&
                                    typePayment === "pagseguro-pix"
                                      ? "type-method-selected"
                                      : "type-method"
                                  }
                                  onClick={() =>
                                    changePayment("pagseguro-pix", payment.id)
                                  }
                                >
                                  <img src={PixImg} alt="Pix" />
                                  <p>Pix</p>
                                </div>
                              </>
                            );
                          } else {
                            return (
                              <div
                                className={
                                  gatewayIdSelected === payment.id &&
                                  typePayment === "pagseguro-card"
                                    ? "type-method-selected"
                                    : "type-method"
                                }
                                onClick={() =>
                                  changePayment("pagseguro-card", payment.id)
                                }
                              >
                                <i
                                  className="fa fa-credit-card"
                                  style={{
                                    color: "#3C9EE5",
                                    width: "32px",
                                    height: "auto",
                                  }}
                                />
                                <p>Cartão de crédito</p>
                              </div>
                            );
                          }
                        case 47:
                          return (
                            <div
                              className={
                                gatewayIdSelected === payment.id &&
                                typePayment === "rede-card"
                                  ? "type-method-selected"
                                  : "type-method"
                              }
                              onClick={() =>
                                changePayment("rede-card", payment.id)
                              }
                            >
                              <i
                                className="fa fa-credit-card"
                                style={{
                                  color: "#3C9EE5",
                                  width: "32px",
                                  height: "auto",
                                }}
                              />
                              <p>Cartão de crédito</p>
                            </div>
                          );
                      }
                    }
                    if (payment.id === config?.content.pdv.gatewayPixId) {
                      switch (payment.plugintemplateId.id) {
                        case 10:
                          if (payment.content.pix === "1") {
                            return (
                              <>
                                <div className={"payment-card-option"}>
                                  <span>Pix</span>
                                </div>
                                <div
                                  className={
                                    gatewayIdSelected === payment.id &&
                                    typePayment === "pagseguro-pix"
                                      ? "type-method-selected"
                                      : "type-method"
                                  }
                                  onClick={() =>
                                    changePayment("pagseguro-pix", payment.id)
                                  }
                                >
                                  <img src={PixImg} alt="Pix" />
                                  <p>Pix</p>
                                </div>
                              </>
                            );
                          } else return <></>;
                        case 25:
                          if (wallets) {
                            return wallets.map((wallet: WalletType) => (
                              <div
                                className={
                                  gatewayIdSelected === payment.id &&
                                  typePayment === `${wallet.code}-wallet`
                                    ? "type-method-selected"
                                    : "type-method"
                                }
                                onClick={() =>
                                  changePayment(
                                    `${wallet.code}-wallet`,
                                    payment.id
                                  )
                                }
                              >
                                <img src={wallet.logo} alt={wallet.name} />
                                <p>{wallet.name}</p>
                              </div>
                            ));
                          }
                          break;
                      }
                    }
                  })}
                </div>
              )}
              {momentType === "after" && (
                <div className="payment-tab-moment-type">
                  {paymentsAfter.find(
                    (payment) =>
                      payment.typePay === "Credit" &&
                      payment.cardOperator !== 100 && //Dinheiro
                      payment.cardOperator !== 99 && //PIX
                      payment.cardOperator !== 23 && //Sodex
                      payment.cardOperator !== 26 && //VR
                      payment.cardOperator !== 10 && //Alelo
                      payment.cardOperator !== 27 //Ticket
                  ) &&
                    paymentsAfterAble.ableCredit && (
                      <>
                        <div className={"payment-card-option"}>
                          <span>Cartão de crédito</span>
                        </div>
                        {paymentsAfter
                          .filter(
                            (payment) =>
                              payment.typePay === "Credit" &&
                              payment.cardOperator !== 100 && //Dinheiro
                              payment.cardOperator !== 99 && //PIX
                              payment.cardOperator !== 23 && //Sodex
                              payment.cardOperator !== 26 && //VR
                              payment.cardOperator !== 10 && //Alelo
                              payment.cardOperator !== 27 //Ticket
                          )
                          .map((payment) => (
                            <div
                              className={
                                payment.id === selectedPaymentAfter?.id
                                  ? "type-method-selected"
                                  : "type-method"
                              }
                              onClick={() => {
                                changePayment(
                                  "delivery-payment",
                                  payment.pluginconfigId
                                );
                                setTypeAfter("card");
                                setSelectedPaymentAfter(payment);
                              }}
                            >
                              {cardIcon(payment.brand.toLowerCase())}
                              <p>{payment.brand}</p>
                            </div>
                          ))}
                      </>
                    )}
                  {paymentsAfter.find(
                    (payment) =>
                      payment.typePay === "Debit" &&
                      payment.cardOperator !== 100 && //Dinheiro
                      payment.cardOperator !== 99 && //PIX
                      payment.cardOperator !== 23 && //Sodex
                      payment.cardOperator !== 26 && //VR
                      payment.cardOperator !== 10 && //Alelo
                      payment.cardOperator !== 27 //Ticket
                  ) &&
                    paymentsAfterAble.ableDebit && (
                      <>
                        <div className={"payment-card-option"}>
                          <span>Cartão de débito</span>
                        </div>
                        {paymentsAfter
                          .filter(
                            (payment) =>
                              payment.typePay === "Debit" &&
                              payment.cardOperator !== 100 && //Dinheiro
                              payment.cardOperator !== 99 && //PIX
                              payment.cardOperator !== 23 && //Sodex
                              payment.cardOperator !== 26 && //VR
                              payment.cardOperator !== 10 && //Alelo
                              payment.cardOperator !== 27 //Ticket
                          )
                          .map((payment) => (
                            <div
                              className={
                                payment.id === selectedPaymentAfter?.id
                                  ? "type-method-selected"
                                  : "type-method"
                              }
                              onClick={() => {
                                changePayment(
                                  "delivery-payment",
                                  payment.pluginconfigId
                                );
                                setTypeAfter("debit-card");
                                setSelectedPaymentAfter(payment);
                              }}
                            >
                              {cardIcon(payment.brand.toLowerCase())}
                              <p>{payment.brand}</p>
                            </div>
                          ))}
                      </>
                    )}
                  {paymentsAfter.find(
                    (payment) =>
                      payment.typePay === "Credit" &&
                      (payment.cardOperator == 23 || //Sodex
                        payment.cardOperator == 26 || //VR
                        payment.cardOperator == 10 || //Alelo
                        payment.cardOperator == 27) //Ticket
                  ) &&
                    paymentsAfterAble.ableAlimentation && (
                      <>
                        <div className={"payment-card-option"}>
                          <span>Alimentação</span>
                        </div>
                        {paymentsAfter
                          .filter(
                            (payment) =>
                              payment.typePay === "Credit" &&
                              (payment.cardOperator == 23 || //Sodex
                                payment.cardOperator == 26 || //VR
                                payment.cardOperator == 10 || //Alelo
                                payment.cardOperator == 27) //Ticket
                          )
                          .map((payment) => (
                            <>
                              <div
                                className={
                                  payment.id === selectedPaymentAfter?.id
                                    ? "type-method-selected"
                                    : "type-method"
                                }
                                onClick={() => {
                                  changePayment(
                                    "delivery-payment",
                                    payment.pluginconfigId
                                  );
                                  setTypeAfter("food");
                                  setSelectedPaymentAfter(payment);
                                }}
                              >
                                {cardIcon(payment.brand.toLowerCase())}
                                <p>{payment.brand}</p>
                              </div>
                            </>
                          ))}
                      </>
                    )}
                  {paymentsAfterAble.ablePix &&
                    paymentsAfter
                      .filter((payment) => payment.cardOperator === 99)
                      .map((payment) => (
                        <>
                          <div className={"payment-card-option"}>
                            <span>Pix</span>
                          </div>
                          <div
                            className={
                              typeAfter === "pix"
                                ? "type-method-selected"
                                : "type-method"
                            }
                            onClick={() => {
                              changePayment(
                                "delivery-payment",
                                payment.pluginconfigId
                              );
                              setTypeAfter("pix");
                              setSelectedPaymentAfter(payment);
                            }}
                          >
                            <img src={PixImg} alt="Pix" />
                            <p>Pix</p>
                          </div>
                        </>
                      ))}
                  {paymentsAfterAble.ableMoney &&
                    paymentsAfter.map((payment) => {
                      if (payment.cardOperator === 100) {
                        return (
                          <>
                            <div className={"payment-card-option"}>
                              <span>Dinheiro</span>
                            </div>
                            {
                              <>
                                <div
                                  className={
                                    selectedPaymentAfter &&
                                    selectedPaymentAfter.id === payment.id
                                      ? "type-method-selected"
                                      : "type-method"
                                  }
                                  onClick={() => {
                                    setTypeAfter("money");
                                    changePayment(
                                      "delivery-payment",
                                      payment.pluginconfigId
                                    );
                                    setSelectedPaymentAfter(payment);
                                    setPaymentMoney(total.toFixed(2));
                                  }}
                                >
                                  <i
                                    className="fa fa-money-bill"
                                    style={{ color: "#E19C15" }}
                                  ></i>
                                  <p>Pagamento em dinheiro</p>
                                </div>

                                {typeAfter === "money" && (
                                  <div>
                                    <Switch
                                      change={(value: boolean) => {
                                        setNeedChanges(value);

                                        if (value) {
                                          setPaymentMoney("0");
                                        } else {
                                          setPaymentMoney(total.toFixed(2));
                                        }
                                      }}
                                      value={needChanges}
                                      label="Precisa de troco?"
                                    />
                                  </div>
                                )}

                                {needChanges && (
                                  <div className="inputs-change">
                                    <div
                                      className="input"
                                      style={{ width: "60%" }}
                                    >
                                      <label>Troco para</label>
                                      <Input
                                        inputAttr={{
                                          type: "money",
                                        }}
                                        label={""}
                                        textCenter={true}
                                        placeholder="Pagamento"
                                        value={paymentMoney}
                                        locale="pt-BR"
                                        currency="BRL"
                                        change={(value: string) =>
                                          setPaymentMoney(value)
                                        }
                                        backgroundColor={"#dbdbdb"}
                                      />
                                    </div>
                                    <div
                                      className="input disable"
                                      style={{ width: "40%" }}
                                    >
                                      <label>Esse será o troco</label>
                                      <div className="money-changes">
                                        <span>
                                          R${" "}
                                          {parseFloat(paymentMoney) > 0
                                            ? (
                                                parseFloat(paymentMoney) - total
                                              ).toFixed(2)
                                            : parseFloat(
                                                (0 * -1).toString()
                                              ).toFixed(2)}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </>
                            }
                          </>
                        );
                      } else {
                        return null;
                      }
                    })}
                </div>
              )}
            </div>
            <div className="footer-button-order-info">
              <MainButton
                color={
                  config?.webappcolor.fontbutton
                    ? config.webappcolor.fontbutton
                    : "#636363"
                }
                backgroundColor={
                  config?.webappcolor.webappbutton
                    ? config.webappcolor.webappbutton
                    : "#EAEAEA"
                }
                text="Continuar"
                onClick={choosePayment}
              />
            </div>
          </div>
        )}
        {!loadingHeader && (
          <Menu
            activeMenu="cart"
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
      </div>
    </div>
  );
}
